import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';

import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import pluralize from 'rebook/apps/utils/text/pluralize';
import BooksetListEmpty from 'rebook/apps/base/components/BooksetListEmpty';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';

import StackBookCover from 'rebook/apps/base/components/stackBookCover';

import styles from './style.scss';


const BookTagsCarousel = (
  { bookTag, bookTagCount, title, link, linkText, extraClassName },
) => {
  title = typeof title !== 'string'
    ? title
    : (
      <div className="title-2">
        {title}
      </div>
    );
  return (
    <div className={classNames('billetContainerNoOverflow', styles.bookset, extraClassName)}>
      {get(bookTag, 'length', 0) > 0
        ? (
          <React.Fragment>
            <div className={styles.title}>
              <div>
                {title}
                {bookTagCount > 0 && (
                  <div className={styles.subtitle}>
                    {numberWithSpace(bookTagCount)}&nbsp;
                    {pluralize(bookTagCount, 'тема', 'темы', 'тем')}
                  </div>
                )}
              </div>
              {Object.keys(link).length > 0 && (
                <Link to={link} className={styles.link}>
                  {linkText.length > 0 && (
                    <span className={classNames('link', styles.linkText)}>{linkText}</span>
                  )}
                </Link>
              )}
            </div>
            <ContentCarousel>
              {bookTag.map((item) => {
                let audioBooks = get(item, 'preview_audio_covers',);
                let textBooks = get(item, 'preview_text_covers',);
                let itemCounter = get(item.counters, 'books', 0);
                let audioBooksExists = audioBooks && audioBooks.length > 0;
                return (
                  <Link to={`/tags/${item.slug}/`}
                    className={styles.wrapper}
                    style={{ width: audioBooksExists ? '170px' : '120px' }}
                    key={item.id}>
                    <StackBookCover audioBooks={audioBooks} textBooks={textBooks} />
                    <div className={styles.tagHeading}>
                      {item.name}
                    </div>
                    <div className={styles.tagCounter}>
                      {itemCounter} {pluralize(itemCounter, 'книга', 'книги', 'книг')}
                    </div>
                  </Link>
                );
              })}
            </ContentCarousel>
          </React.Fragment>
        )
        : (
          <React.Fragment>
            <div className="billetContainerWrapper">
              <div className={styles.titleEmpty} />
              <div className={styles.subTitleEmpty} />
            </div>
            <div className={styles.booksetListEmpty}>
              <BooksetListEmpty />
            </div>
          </React.Fragment>
        )
      }
    </div>
  );
};

BookTagsCarousel.propTypes = {
  bookTag: PropTypes.array,
  bookTagCount: PropTypes.number,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  link: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  linkText: PropTypes.string,
};

BookTagsCarousel.defaultProps = {
  bookTag: [],
  bookTagCount: 0,
  title: null,
  link: '',
  linkText: '',
};

export default BookTagsCarousel;
